(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateEditMusicianController', CreateEditMusicianController);

    CreateEditMusicianController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog', 'countries', 'emojiReplacer', 'cache', 'eventTracker'];

    function CreateEditMusicianController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog, countries, emojiReplacer, cache, eventTracker) {
        var phone;
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.no_scroll = true;
        var vm = this;
        vm.$onInit = init;
        vm.save = save;
        vm.softDelete = softDelete;
        vm.close = close;
        vm.countries = countries;
        vm.selectGenre = selectGenre;
        vm.selectedGenres = selectedGenres;
        vm.selectCareerState = selectCareerState;
        vm.formIsValid = formIsValid;
        vm.privateConcertDetailsInfo = privateConcertDetailsInfo;
        vm.setBookingLevels = setBookingLevels;
        vm.setCountryRegions = setCountryRegions;
        vm.updateCountryRegions = updateCountryRegions;
        vm.bookingLevels = [];
        vm.countryRegions = [];
        vm.notInterested = 0;
        vm.getSelectedMainGenreName = getSelectedMainGenreName;

        vm.canDelete = true;

        function init() {
            vm.loaded = false;
            vm.slug = $stateParams.band_slug;
            vm.band = {};
            getGenres();
            getCurrencies();
            getUser();
            getBookingLevels();
            getCountryRegions();

            var unregister_uploaded_image_exists_event = $rootScope.$on('uploaded_image_exists', function (event, args) {
                if (args.type === 'bands' && args.image_number == 1) {
                    vm.header_image_set = args.image_exists;
                }
            });
            $scope.$on('$destroy', unregister_uploaded_image_exists_event);

            var unregister_uploaded_image_temp = $rootScope.$on('uploaded_image_temp', function (event, args) {

                vm.upload_image_slug = args.temp_slug;
            });
            $scope.$on('$destroy', function () {
                unregister_uploaded_image_temp();
                $rootScope.no_scroll = false;
            });


            if (!vm.slug) {
                vm.band.selected_genres = [];
                vm.band.band_country = 'DK';
                vm.band.band_price_currency = 'dkk';
                vm.slug = "new";
                vm.band.band_available_for_private_booking = "1";
                vm.band.band_career_state = null;
                vm.loaded = true;
            } else {
                getContent();
            }

            setTimeout(function () {
                var input = document.querySelector("#phone");
                phone = window.intlTelInput(input, {
                    utilsScript: "app/assets/js/utils.js",
                    preferredCountries: ["dk", "gb", "se"],
                    defaultCountry: "dk",
                    formatOnDisplay: false,
                    customContainer: "international-phone-input"
                });
                input.addEventListener("countrychange", function (e) {
                    vm.bandForm.$setDirty();
                    $scope.$apply();
                });
            }, 0);

        }

        function privateConcertDetailsInfo() {
            dialog.info('private-concert-details-info');
        }

        $scope.$on("$locationChangeStart", function (event) {
            if (vm.bandForm && vm.bandForm.$dirty) {
                event.preventDefault();
                close();
            }
        });

        function getUser() { //Gets information about the currently logged-in user
            $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    $rootScope.user_stripe_connection = response.data.user_stripe_connected_account_token;
                    setTimeout(function () {
                        if (vm.user.user_phone_country_code) {
                            phone.setCountry(vm.user.user_phone_country_code);
                        }
                        phone.setNumber(vm.user.user_phone);
                    }, 10);
                })
        }

        function getBookingLevels() {
            $http.get('api/booking_levels/')
                .then(function (response) {
                    vm.allBookingLevels = response.data;
                    setBookingLevels();
                })
        }

        function getCountryRegions() {
            $http.get('api/country_regions/')
                .then(function (response) {
                    vm.allCountryRegions = response.data;
                    if (vm.band.band_country) {
                        setCountryRegions();
                    }
                })
        }

        function setBookingLevels() {
            vm.bookingLevels = vm.allBookingLevels.filter(function (bookingLevel) {
                return bookingLevel.price_range_currency == vm.band.band_price_currency || bookingLevel.booking_level_id == 0;
            });
        }

        function setCountryRegions() {
            vm.countryRegions = vm.allCountryRegions.filter(function (countryRegion) {
                return countryRegion.country_iso_code == vm.band.band_country;
            });
        }

        function updateCountryRegions() {
            vm.band.band_country_region_id = null;
            vm.countryRegions = vm.allCountryRegions.filter(function (countryRegion) {
                return countryRegion.country_iso_code == vm.band.band_country;
            });
        }

        function close() {
            if (!vm.waiting_for_verification && vm.bandForm && vm.bandForm.$dirty) {
                if (vm.band.band_published) {
                    dialog.prompt('unsaved-changes-prompt', function (response) {
                        if (response.confirm) {
                            leave();
                        }
                        if (response.alternative) {
                            vm.bandForm.$setSubmitted();
                            save().then(function () {
                                leave();
                            });
                        }
                    }, true);
                } else {
                    dialog.prompt('unsaved-changes-draft-prompt', function (response) {
                        if (response.confirm) {
                            leave();
                        }
                        if (response.alternative) {
                            save(true).then(function () {
                                leave();
                            });
                        }
                    }, true);
                }
            } else {
                leave();
            }
        }

        function selectedGenres() {
            var selectedGenres = [];
            if (vm.genres) {
                vm.genres.forEach(function (genre) {
                    if (genre.selected) {
                        selectedGenres.push(genre)
                    }
                });
            }
            return selectedGenres;
        }

        function selectGenre(genre) {
            if (!genre.selected && selectedGenres().length == 3) {
                return;
            }
            if (!vm.band.band_main_genre && selectedGenres().length == 0) {
                vm.band.band_main_genre = genre.filter_value_id
            }
            genre.selected = !genre.selected;
            if (!genre.selected && genre.filter_value_id == vm.band.band_main_genre && selectedGenres().length > 0) {
                vm.band.band_main_genre = selectedGenres()[0].filter_value_id
            }
            if (vm.band.band_main_genre && selectedGenres().length == 0) {
                vm.band.band_main_genre = null;
            }
            vm.bandForm.$setDirty();
        }

        function getGenres() {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
                return $http.get('api/genres/')
                    .then(function (response) {
                        vm.genres = response.data;
                        cache.save('genres', vm.genres);
                    });
            }
        }

        function getSelectedMainGenreName() {
            return vm.genres.filter(function (genre) { return genre.filter_value_id == vm.band.band_main_genre; })[0].filter_value_name;
        }

        function getCurrencies() {
            return $http.get('api/currencies/')
                .then(function (response) {
                    vm.currencies = response.data;
                });
        }

        function getContent() {
            return $http.get('api/bands/' + vm.slug + '/')
                .then(function (response) {
                    if(!response.data.user_is_band_admin){
                        return $state.go('frontpage');
                    }
                    vm.band = response.data;
                    var band_inspired_by_split = vm.band.band_inspired_by.split(', ');
                    vm.band.band_inspired_by_1 = band_inspired_by_split[0] ? band_inspired_by_split[0] : '';
                    vm.band.band_inspired_by_2 = band_inspired_by_split[1] ? band_inspired_by_split[1] : '';
                    vm.band.band_inspired_by_3 = band_inspired_by_split[2] ? band_inspired_by_split[2] : '';

                    if (!vm.band.band_published && !vm.band.band_is_draft) {
                        vm.waiting_for_verification = true;
                    }
                    setBookingLevels();
                    setCountryRegions();
                    makeBandShadow();
                    vm.genres.forEach(function (genre) {
                        vm.band.selected_genres.forEach(function (selected_genre) {
                            if (genre.filter_value_id == selected_genre.filter_value_id) {
                                genre.selected = true;
                                if (!vm.band.band_main_genre) {
                                    vm.band.band_main_genre = genre.filter_value_id;
                                }
                            }
                        })
                    });

                    if(vm.band.primary_image && vm.band.primary_image.length == 0) {
                        vm.band.primary_image = null;
                    }

                    vm.loaded = true;
                    $scope.$applyAsync();
                });
        }

        function updateUser() { //Updates data about user based on inputted data
            if (vm.user.user_phone !== "") {
                var data = {
                    band_description_long: emojiReplacer.replaceEmojis(vm.band.band_description_long),
                    band_description_short: emojiReplacer.replaceEmojis(vm.band.band_description_short),
                    user_phone: phone.getNumber(),
                    user_phone_country_code: phone.getSelectedCountryData().iso2.toUpperCase()
                };

                $http.patch('api/users/' + vm.user.user_slug + '/', data)
                    .then(function (response) { //Sets cookies corresponding to the new data
                        console.log('api/users/' + vm.user.user_slug + '/ response', response);
                    });
            }

        }

        function formIsValid() {
            return vm.bandForm.$valid && vm.band.primary_image && vm.band.band_description_short.length >= 80 && vm.band.band_description_short.length <= 165 && vm.band.band_description_long.length >= 100 && vm.band.band_description_long.length <= 800 && vm.band.band_career_state != null && selectedGenres().length > 0;
        }

        function save(is_draft) {
            vm.save_data = 1;
            vm.phone_country_set = phone.getSelectedCountryData().iso2;
            if (!is_draft && !formIsValid()) {
                setTimeout(function () {
                    document.querySelector('.scroll-child').scrollTop = document.querySelector('.scroll-child').scrollHeight;
                }, 0);
                return false;
            } else if (is_draft && !vm.band.band_name) {
                vm.showBandNameRequired = true;
                return;
            }
            if (!is_draft) {
                vm.hideDraftButton = true;
            }
            vm.showBandNameRequired = false;
            updateUser();

            vm.save_progress = 'saving';
            var data = {
                band_published: vm.band.band_published,
                band_name: vm.band.band_name,
                band_price_currency: vm.band.band_price_currency,
                band_description_long: emojiReplacer.replaceEmojis(vm.band.band_description_long),
                band_description_short: emojiReplacer.replaceEmojis(vm.band.band_description_short),
                band_location: vm.band.band_location,
                band_zip: vm.band.band_zip,
                band_city: vm.band.band_city,
                band_postal_code_id: vm.city_search ? vm.city_search.postal_code_id : null,
                band_country: vm.band.band_country,
                band_country_region_id: vm.band.band_country_region_id,
                band_spotify: vm.band.band_spotify,
                band_facebook: vm.band.band_facebook,
                band_youtube: vm.band.band_youtube,
                band_youtube_channel: vm.band.band_youtube_channel,
                band_bandcamp: vm.band.band_bandcamp,
                band_instagram: vm.band.band_instagram,
                band_soundcloud: vm.band.band_soundcloud,
                band_link: vm.band.band_link,
                band_inspired_by:
                    (vm.band.band_inspired_by_1 ? vm.band.band_inspired_by_1 : '')
                    + (vm.band.band_inspired_by_2 ? ', ' + vm.band.band_inspired_by_2 : '')
                    + (vm.band.band_inspired_by_3 ? ', ' + vm.band.band_inspired_by_3 : ''),
                genres: selectedGenres(),
                upload_image_slug: vm.upload_image_slug,
                band_available_for_private_booking: vm.band.band_available_for_private_booking,
                booking_level_id: vm.band.booking_level_id,
                band_main_genre: vm.band.band_main_genre,
                band_career_state: vm.band.band_career_state,
                band_is_draft: is_draft == undefined ? 0 : 1,
                primary_image: vm.band.primary_image,
                secondary_images: vm.band.secondary_images
            };

            if (vm.slug === 'new') {
                return $http.post('api/bands/', data)
                    .then(function (response) {
                        if (cache.exists('user_bands')) {
                            cache.reset('user_bands');
                        }
                        if (response.data !== undefined && response.data.band_slug !== undefined) {
                            vm.save_progress = 'success';
                            $rootScope.no_scroll = false;
                            if (is_draft) {
                                $state.go('edit_musician', { 'band_slug': response.data.band_slug }, { location: 'replace' }).then(function () {
                                    $state.go('member', { tab: 'profiles' });
                                });
                            } else {
                                if (vm.band.band_country == 'DK' || vm.band.band_country == 'SE') {
                                    eventTracker.artistSignup({
                                        'country': data.band_country,
                                        'region': vm.allCountryRegions[vm.band.band_country_region_id - 1].country_region_name,
                                        'careerState': data.band_career_state,
                                        'genre': getSelectedMainGenreName()
                                    });
                                    vm.bandForm.$setSubmitted();
                                } if ((vm.band.band_country != 'DK' && vm.band.band_country != 'SE')) {
                                    eventTracker.artistSignup({
                                        'country': data.band_country,
                                        'region': 'no region data available',
                                        'careerState': data.band_career_state,
                                        'genre': getSelectedMainGenreName()
                                    });
                                    vm.bandForm.$setSubmitted();
                                }
                                $state.go('edit_musician', { 'band_slug': response.data.band_slug });
                            }

                        }
                    });
            } else {
                return $http.patch('api/bands/' + vm.slug + '/', data)
                    .then(function (response) {
                        if (cache.exists('user_bands')) {
                            cache.reset('user_bands');
                        }
                        vm.save_progress = 'success';
                        vm.bandForm.$setPristine();
                        if (!is_draft) {
                            if (vm.band.band_country == 'DK' || vm.band.band_country == 'SE') {
                                eventTracker.artistSignup({
                                    'country': data.band_country,
                                    'region': vm.allCountryRegions[vm.band.band_country_region_id - 1].country_region_name,
                                    'careerState': data.band_career_state,
                                    'genre': getSelectedMainGenreName()
                                });
                                vm.bandForm.$setSubmitted();
                            } if ((vm.band.band_country != 'DK' && vm.band.band_country != 'SE')) {
                                eventTracker.artistSignup({
                                    'country': data.band_country,
                                    'region': 'no region data available',
                                    'careerState': data.band_career_state,
                                    'genre': getSelectedMainGenreName()
                                });
                                vm.bandForm.$setSubmitted();
                            }
                        }
                        if (!is_draft && !vm.band.band_published) {
                            vm.waiting_for_verification = true;
                        }
                        vm.save_progress = 'success';
                        makeBandShadow();
                        leave();
                    });
            }
        }

        function publish() {
            if (vm.BandForm.$invalid || vm.band.selected_genres.length < 1 || vm.band.selected_moods.length < 1 || vm.band.selected_event_types.length < 1 || !vm.band.primary_image) {
                angular.forEach(vm.BandForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                vm.form_validated = true;
            } else {
                vm.band.band_published = 1;
                save();
            }
        }

        function selectCareerState(careerState) {
            vm.band.band_career_state = careerState;
        }

        function softDelete() {
            dialog.prompt('delete-draft-prompt', function (response) {
                if (response.confirm) {
                    $http.delete('api/bands/' + vm.slug + '/')
                        .then(function () {
                            if (cache.exists('user_bands')) {
                                cache.clear('user_bands');
                            }
                            leave();
                        });
                }
            });
        }

        function leave() {
            $rootScope.no_scroll = false;
            if ($stateParams.return_page) {
                return $state.go($stateParams.return_page, $stateParams.return_params);
            } else {
                return $state.go('member', { tab: 'profiles' });
            }
        }

        function makeBandShadow() {
            vm.band_shadow = angular.copy(vm.band);
        }
    }
})();
